import classNames from 'classnames';
import type { FC } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { routeTitles } from '../../constants/routeTitles';
import { useIsDesktop } from '../../hooks/useIsDesktop';
import styles from './Breadcrumb.module.scss';
import { useBreadCrumbs } from './useBreadcrumbs';

type BreadcrumbProps = {
  className?: string | undefined;
};

export const Breadcrumb: FC<BreadcrumbProps> = ({ className }) => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter(Boolean);

  const crumbs = useBreadCrumbs(pathnames);

  const isDesktop = useIsDesktop();

  return (
    <div
      className={classNames(
        styles.breadcrumb,
        {
          [styles['fixed-spacing']]: isDesktop,
        },
        className,
      )}
    >
      {crumbs.length > 0 && (
        <>
          <div className={styles.link}>
            <Link className={styles.link} to='/'>
              {routeTitles.root}
            </Link>
          </div>
          {crumbs.map((crumb, index) => (
            <div key={index} className={styles.link}>
              <Link className={styles.link} to={crumb.slug}>
                {crumb.title}
              </Link>
            </div>
          ))}
        </>
      )}
    </div>
  );
};
